import { PayloadAction } from '@reduxjs/toolkit';
import { deleteUser } from '../../api/users/deleteUser';
import { GenericState } from '../../types/apiModule';
import { User } from '../../types/users/users';
import createApiModule from '../createApiModule';
import { showSnackBar } from '../snackBar/snackBarSlice';
import { listUsersRefresh } from './listUserModule';
import { t } from '../../i18n';
export interface deleteUserState extends GenericState<unknown> {
  active: boolean;
  data: User[];
  user: User | null;
}
const initialState: deleteUserState = {
  errors: null,
  loading: false,
  data: [],
  active: false,
  user: null,
};
const deleteUserModule = createApiModule({
  name: 'deleteUser',
  initialState,
  apiMethod: deleteUser,
  onSuccess: () => [
    showSnackBar({
      severity: 'success',
      message: t('MESSAGE_USUARIO_ELIMINADO'),
    }),
    listUsersRefresh(),
  ],
  onError: (error) => ({
    message: t(
      'StoreUsersDeleteUserModuleNoSePuedeBorrarElLaUsuarioAAsegurateQueHayOtroCoordinadorResponsableCreados',
    ),
  }),
  onValidationError: (error) => ({
    message: error ? error.message : 'Error borrando el/la usuario/a',
  }),
  reducers: {
    show(state, action: PayloadAction<User>) {
      state.active = true;
      state.user = action.payload;
    },
    hide(state) {
      state.active = false;
    },
  },
});

export const {
  start: del,
  success: delOk,
  error: delKo,
  hide,
  show,
} = deleteUserModule.slice.actions;

export default deleteUserModule;
